export default __webpack_public_path__ + "static/media/office7small.c6cb1861.jpg";